import { ISelectItem } from '@lla-platform/core/core-ui'

/** Read-model view of a vendor document's posted flag (see GLOSSARY.md "Unposted"). */
export enum VendorDocumentStatus {
  Posted = 'Posted',
  Unposted = 'Unposted'
}

export const VendorDocumentStatusToLabel: Record<string, string> = {
  Posted: 'Posted',
  Unposted: 'Unposted'
}

export const VendorDocumentStatusItems: ISelectItem[] = Object.values(VendorDocumentStatus).map(
  (value) => ({
    label: VendorDocumentStatusToLabel[value],
    value
  })
)
